import React from 'react';
import './Cover.scss';
import coverImageMobile from '../../assets/images/about__cover_mobile.jpg';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Cover = ({ coverImage }) => {
  return (
    <>
      <article className="about__cover cover">
        <h2 className="cover__title">
          I have 9+ years in design, with 6+ years dedicated to UX/ UI and Product Design
        </h2>
        <div className="cover__content">
          <div className="cover__text-container">
            <p>
              I’m <span>passionate about design & travel</span>
            </p>
            <p>
              I find inspiration in local rhythm, architecture, and atmosphere — and bring those
              observations back into my work
            </p>
            <p>
              Based in <span>Tel-Aviv, Israel</span>
            </p>
          </div>
          <div className="cover__image-container">
            <img src={window.innerWidth >= 853 ? coverImage : coverImageMobile} alt="Cover" />
          </div>
        </div>
      </article>
    </>
  );
};

export default Cover;
